import React from 'react';
import Navbar from './Navbar';
import ContactUs from './ContactUs';

function Refund() {
  return (
    <div>
      <Navbar />
      <div style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          color: 'black',
          marginBottom: '2rem'
        }}>
          Refund and Cancellation Policy
        </h1>

        {/* Content Box */}
        <div style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          color: '#1E4CA4', // Medium blue
          fontSize: '1rem',
          lineHeight: '1.8',
          whiteSpace: 'pre-wrap',
        }}>
          <p>
            Vilvattam Service Coopertive Bank Ltd (VSCB) does not provide refund & cancellation as we are a primary agricultural co-operative credit society, thus we require payment Gateway to receive loan repayment from our customers.

            {"\n\n"}Amount once paid through the payment gateway shall not be refunded other than in the following circumstances:
            {"\n"}- Multiple times debiting of Customers Card/Bank Account due to technical error OR Customers account being debited with excess amount in a single transaction due to technical error. In such cases, excess amount excluding Payment Gateway charges would be refunded to the Customer.
            {"\n"}- Due to technical error, payment being charged on the Customers Card/Bank Account but the transaction is unsuccessful.

            {"\n\n"}Vilvattam Service Cooperative Bank Ltd does not provide refund & cancellation as we are a primary agricultural credit society, thus we require payment Gateway to receive loan repayment from our customers.

            {"\n\n"}The Customer will have to make an application for refund along with the transaction number and original payment receipt if any generated at the time of making payments.

            {"\n\n"}The application in the prescribed format should be sent to www.vilvattamscb337.com.

            {"\n\n"}The application will be processed manually and after verification, if the claim is found valid, the amount received in excess will be refunded by VSCB through electronic mode in favour of the borrower and confirmation sent to the mailing address given to us, within a period of 7 calendar days on receipt of such claim. It will take 3–7 days for the money to show in your bank account depending on your bank's policy.

            {"\n\n"}The VSCB assumes no responsibility and shall incur no liability if it is unable to affect any Payment Instruction(s) on the Payment Date owing to any one or more of the following circumstances:
            {"\n"}- If the Payment Instruction(s) issued by you is/are incomplete, inaccurate, invalid, or delayed.
            {"\n"}- If the Payment Account has insufficient funds/limits to cover for the amount.
            {"\n"}- If the funds available in the Payment Account are under any encumbrance or charge.
            {"\n"}- If your Bank refuses or delays honoring the Payment Instruction(s).
            {"\n"}- Circumstances beyond the control of VSCB (e.g. fire, flood, natural disasters, strikes, power failure, system failure, etc.)

            {"\n\n"}In case the payment is not effected for any reason, you will be intimated about the failed payment by an e-mail.

            {"\n\n"}User agrees that the VSCB, in its sole discretion, for any or no reason, and without penalty, may suspend or terminate his/her account (or any part thereof) or use of the Services and remove and discard all or any part of his/her account or profile at any time. VSCB may also in its sole discretion and at any time discontinue providing access to the Services with or without notice.

            {"\n\n"}User agrees that any termination of access to the Services may be effected without prior notice and that VSCB will not be liable to User or any third party for such termination. Any suspected, fraudulent, abusive, or illegal activity may be referred to appropriate law enforcement authorities.

            {"\n\n"}These remedies are in addition to any other remedies VSCB may have. Upon termination for any reason, the user agrees to immediately stop using the Services.
          </p>
        </div>
      </div>
      <ContactUs/>
    </div>
  );
}

export default Refund;
